import { jsxs as p, jsx as e } from "react/jsx-runtime";
import { z as a } from "zod";
import { withZod as i } from "@made-people/react-prop-guard";
import { withManagedProps as d } from "@made-people/managed-props";
import { pageHeaderKrakowBlueprint as z, pageHeaderGdanskBlueprint as j } from "./index-blueprint.es.js";
import { breadcrumbsSchema as f, Breadcrumbs as b } from "@made-people/blueprint-breadcrumbs";
import { responsiveImageSchema as w, ResponsiveImage as v } from "@made-people/blueprint-responsive-image";
import { textBlockSchema as y, TextBlock as l } from "@made-people/blueprint-text-block";
import { componentWrapperSchema as x, ComponentWrapper as S } from "@made-people/blueprint-component-wrapper";
import { linkShortcutsSchema as B, LinkShortcuts as H } from "@made-people/blueprint-link-shortcuts";
import "@made-people/blueprint";
const k = a.object({
  layout: x.shape.layout.optional(),
  textBlock: y.optional(),
  breadcrumbsSettings: f.optional(),
  image: w.optional(),
  template: a.literal("krakow"),
  variants: a.custom().optional(),
  linkShortcuts: B.optional()
}), N = d(
  "PageHeaderKrakow",
  i(
    {
      schema: k,
      defaultProps: {
        template: "krakow",
        textBlock: {
          heading: {
            variants: {
              headingSize: "sm"
            }
          },
          enableTruncate: !0,
          variants: {
            layout: "vertical",
            spacing: "false"
          }
        }
      }
    },
    ({
      variants: t,
      textBlock: s,
      image: r,
      layout: m,
      linkShortcuts: o,
      breadcrumbsSettings: c
    }) => {
      const n = z.styles(t);
      return /* @__PURE__ */ p(S, { className: n.base, layout: m, children: [
        (r == null ? void 0 : r.image) && /* @__PURE__ */ e(
          v,
          {
            displaySize: "100vw",
            ...r,
            className: n.image
          }
        ),
        /* @__PURE__ */ e(b, { className: n.breadcrumbs, ...c }),
        s && /* @__PURE__ */ e("div", { className: n.textBlockWrapper, children: /* @__PURE__ */ e(l, { ...s }) }),
        o && /* @__PURE__ */ e("div", { className: n.linkShortcutsWrapper, children: /* @__PURE__ */ e(H, { ...o }) })
      ] });
    }
  )
), u = a.object({
  layout: x.shape.layout.optional(),
  textBlock: y.optional(),
  breadcrumbsSettings: f.optional(),
  image: w.optional(),
  template: a.literal("gdansk"),
  variants: a.custom().optional(),
  linkShortcuts: B.optional()
}), P = d(
  "PageHeaderGdansk",
  i(
    {
      schema: u,
      defaultProps: {
        template: "gdansk",
        textBlock: {
          heading: {
            variants: {
              headingSize: "sm"
            }
          },
          enableTruncate: !0,
          variants: {
            layout: "vertical",
            spacing: "false"
          }
        }
      }
    },
    ({
      variants: t,
      textBlock: s,
      image: r,
      layout: m,
      linkShortcuts: o,
      breadcrumbsSettings: c
    }) => {
      var g, h;
      const n = j.styles(t);
      return /* @__PURE__ */ p(S, { className: n.base, layout: m, children: [
        (r == null ? void 0 : r.image) && /* @__PURE__ */ e(
          v,
          {
            displaySize: "100vw",
            ...r,
            className: n.image
          }
        ),
        /* @__PURE__ */ e(
          b,
          {
            className: n.breadcrumbs,
            layout: {
              spacing: { applySpacing: "false" },
              position: { applyPosition: "false" }
            },
            ...c
          }
        ),
        /* @__PURE__ */ p(l.Root, { ...s, children: [
          /* @__PURE__ */ e(l.Heading, {}),
          ((g = o == null ? void 0 : o.content) == null ? void 0 : g.links) && ((h = o == null ? void 0 : o.content) == null ? void 0 : h.links.length) > 0 && /* @__PURE__ */ e(H, { ...o }),
          /* @__PURE__ */ e(l.Body, {})
        ] })
      ] });
    }
  )
), T = a.discriminatedUnion("template", [
  k.extend({
    template: a.literal("krakow")
  }),
  u.extend({
    template: a.literal("gdansk")
  })
]), D = d(
  "PageHeader",
  i(T, (t) => {
    switch (t.template) {
      case "krakow":
        return /* @__PURE__ */ e(N, { ...t });
      case "gdansk":
        return /* @__PURE__ */ e(P, { ...t });
      default:
        return null;
    }
  })
), W = a.discriminatedUnion("template", [
  k.extend({
    template: a.literal("krakow")
  }),
  u.extend({
    template: a.literal("gdansk")
  })
]), E = i(W, (t) => {
  switch (t.template) {
    case "krakow":
      return /* @__PURE__ */ e(N, { ...t });
    case "gdansk":
      return /* @__PURE__ */ e(P, { ...t });
    default:
      return null;
  }
});
export {
  P as Gdansk,
  N as Krakow,
  D as PageHeader,
  E as TemplateSelector,
  u as gdanskSchema,
  k as krakowSchema,
  T as pageHeaderSchema,
  W as templateSelectorSchema
};
//# sourceMappingURL=index.es.js.map
